const events = {
  WEBSITE_OPEN: "website_open",
  CATEGORY_OPEN: "category_open",
  SERIES_OPEN: "series_open",
  VIDEO_PLAY: "video_play",
  WEBPAGE_OPEN: "webpage_open",
  web_premium_page_viewed: "web_premium_page_viewed",
  web_premium_buy_now_clicked: "web_premium_buy_now_clicked",
  web_premium_login_dialog_viewed: "web_premium_login_dialog_viewed",
  web_premium_login_continue_clicked: "web_premium_login_continue_clicked",
  web_premium_otp_screen_viewed: "web_premium_otp_screen_viewed",
  web_premium_login_successful: "web_premium_login_successful",
  web_premium_razorpay_dialog_viewed: "web_premium_razorpay_dialog_viewed",
  web_premium_razorpay_payment_successful:
    "web_premium_razorpay_payment_successful",
  web_premium_faq_clicked: "web_premium_faq_clicked",
  web_hamburger_clicked: "web_hamburger_clicked",
  web_logo_clicked: "web_logo_clicked",
  web_login_clicked: "web_login_clicked",
  web_download_icon_clicked: "web_download_icon_clicked",
  web_series_open: "web_series_open",
  seekho_safar_opened: "seekho_safar_opened",
  seekho_safar_subscribe_clicked: "seekho_safar_subscribe_clicked",
  ten_seconds_media_played: "ten_seconds_media_played",
  five_seconds_media_played: "five_seconds_media_played",
  video_ended: "video_ended",
  download_apk: "download_apk",
  web_premium_skip_button_clicked: "web_premium_skip_button_clicked",
  start_learning_clicked: "start_learning_clicked",
  auto_read_otp_clicked: "auto_read_otp_clicked",
  hamburger_clicked: "hamburger_clicked",
  payment_mode_selected: "payment_mode_selected",
  login_page_viewed: "login_page_viewed",
  web_premium_series_clicked: "web_premium_series_clicked",
  web_premium_series_popup: "web_premium_series_popup",
  web_truecaller_login: "web_truecaller_login",
  app_store_download_clicked: "app_store_download_clicked",
  refund_contact_button_clicked: "refund_contact_button_clicked",
  blog_download_banner: "blog_download_banner",
  download_app_clicked: "download_app_clicked",
  download_app_qr_viewed: "download_app_qr_viewed",
  eppo_assignment_log: "eppo_assignment_log",
  five_sec_time_spent: "five_sec_time_spent",
  category_pill_clicked: "category_pill_clicked",
  lp_video_clicked: "lp_video_clicked",
  fold_triggered: "fold_triggered",
};

export default events;
